'use client';

import React from 'react';
import Image from 'next/image';
import cn from './style.module.scss';

interface CustomImageProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  fill?: boolean;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
  priority?: boolean;
  style?: React.CSSProperties;
}

export default function CustomImage({
  src,
  alt = '',
  width,
  height,
  className = '',
  fill = false,
  onClick,
  priority = false,
  style,
}: CustomImageProps) {
  const handleContextMenu = (e: React.MouseEvent<HTMLImageElement>) => {
    e.preventDefault();
  };

  if (!src) return null;

  const imageProps = fill ? { fill: true } : { width: width, height: height };

  return (
    <Image
      className={`${cn.customImage} ${className}`}
      src={src}
      alt={alt}
      {...imageProps}
      priority={priority}
      onClick={onClick}
      data-no-visual-search="true"
      role="presentation"
      aria-hidden="true"
      unoptimized
      quality={100}
      onContextMenu={handleContextMenu}
      style={style}
    />
  );
}
